import { Center, Heading, Box } from "@chakra-ui/react";
import hero from '../images/Guitar.jpg'
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";

function Kaartjies() {
  return (
    <>
    <Navbar />
    <Box backgroundImage={hero} backgroundPosition="center"
    backgroundRepeat="no-repeat" width='100%' backgroundSize='cover'>
      <Center minH="100vh">
        <Heading size="4xl">
            Kaartjies binnekort beskikbaar
        </Heading>
          </Center>
          </Box>
    <Footer />
    </>
  );
}

export default Kaartjies;